import React, { useEffect } from 'react';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import LogRocket from 'logrocket';
import { store } from './store';
import browserHistory from './utils/browserHistory';
import process from 'process';
// @ts-ignore
import './style.css';

import { ErrorBoundary } from './helpers/ErrorBoundary';
import { AppRoutes } from './core/AppRoutes';
import { loadInteractJSPlugin } from './core/plugins/interactjs';
import { loadAxiosPlugin } from './core/plugins/axios';
import { mapContext, useMapContextValue } from './map/context/MapContext';
import {
  firebaseContext,
  useFirebaseContextValue,
} from './firebase/FirebaseContext';

loadInteractJSPlugin();
loadAxiosPlugin();

function App() {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      LogRocket.init('pf7bti/edge');
    }
  }, []);

  const mapContextValue = useMapContextValue();
  const firebaseContextValue = useFirebaseContextValue();

  return (
    <ErrorBoundary key="top-level">
      <firebaseContext.Provider value={firebaseContextValue}>
        <mapContext.Provider value={mapContextValue}>
          <Provider store={store}>
            {/* @ts-expect-error */}
            <HistoryRouter history={browserHistory}>
              <AppRoutes />
            </HistoryRouter>
          </Provider>
        </mapContext.Provider>
      </firebaseContext.Provider>
    </ErrorBoundary>
  );
}

export default App;
